module.exports = __webpack_public_path__ + "img/default-institute-logo.79cbe98d.svg";